<div class="competence-i18n">
  <h1 class="competence-i18n__title">Компетенції: переклад і злиття</h1>

  @if (busy) {
    <mat-progress-bar mode="indeterminate" />
  }

  <mat-card class="competence-i18n__card">
    <mat-card-header>
      <mat-card-title>Стан</mat-card-title>
      <mat-card-subtitle>Покриття перекладами і два інваріанти таксономії</mat-card-subtitle>
    </mat-card-header>
    <mat-card-content>
      @if (status$ | async; as status) {
        <div class="competence-i18n__stats">
          <div class="competence-i18n__stat">
            <span class="competence-i18n__value">{{ status.coverage }}%</span>
            <span class="competence-i18n__label">Покриття ({{ status.untranslated }} лишилось)</span>
          </div>
          <div class="competence-i18n__stat">
            <span class="competence-i18n__value">{{ status.activeCompetences }}</span>
            <span class="competence-i18n__label">ACTIVE компетенцій</span>
          </div>
          <div class="competence-i18n__stat">
            <span class="competence-i18n__value">
              {{ status.translations.uk }} / {{ status.translations.en }} / {{ status.translations.ru }}
            </span>
            <span class="competence-i18n__label">Перекладів uk / en / ru</span>
          </div>
          <div class="competence-i18n__stat">
            <span class="competence-i18n__value">{{ status.awaitingVerdict }}</span>
            <span class="competence-i18n__label">Чекають вердикту</span>
          </div>
          <div class="competence-i18n__stat">
            <span class="competence-i18n__value">{{ status.merged }}</span>
            <span class="competence-i18n__label">Злитих</span>
          </div>
          <div class="competence-i18n__stat" [class.competence-i18n__stat--bad]="status.contaminated > 0">
            <span class="competence-i18n__value">{{ status.contaminated }}</span>
            <span class="competence-i18n__label">Відлуння запиту (має бути 0)</span>
          </div>
          <div
            class="competence-i18n__stat"
            [class.competence-i18n__stat--good]="status.invariantsHold"
            [class.competence-i18n__stat--bad]="!status.invariantsHold"
          >
            <span class="competence-i18n__value">{{ status.chains }} / {{ status.cycles }}</span>
            <span class="competence-i18n__label">Ланцюги / цикли (мають бути 0)</span>
          </div>
        </div>
      } @else {
        <p>Стан ще не прочитано.</p>
      }

      <button mat-stroked-button (click)="refreshStatus()">Оновити</button>
    </mat-card-content>
  </mat-card>

  <mat-card class="competence-i18n__card">
    <mat-card-header>
      <mat-card-title>1. Перевірити переклади</mat-card-title>
      <mat-card-subtitle>
        Синхронно, кілька міток. Робити ЗАВЖДИ перед запуском батчу: те, що запишеться, побачить рекрутер, а вікно батчу
        триває годинами.
      </mat-card-subtitle>
    </mat-card-header>
    <mat-card-content>
      <div class="competence-i18n__row">
        <mat-form-field appearance="outline">
          <mat-label>Скільки міток</mat-label>
          <input matInput type="number" min="1" max="25" [(ngModel)]="previewSize" />
        </mat-form-field>
        <button mat-raised-button color="primary" [disabled]="busy" (click)="runPreview()">Перевірити</button>
      </div>

      @if (preview.length) {
        <table class="competence-i18n__preview">
          <thead>
            <tr>
              <th>Мітка</th>
              <th>uk</th>
              <th>en</th>
              <th>ru</th>
            </tr>
          </thead>
          <tbody>
            @for (item of preview; track item.competenceId) {
              <tr>
                <td>{{ item.label }}</td>
                <td>{{ item.translations.uk }}</td>
                <td>{{ item.translations.en }}</td>
                <td>{{ item.translations.ru }}</td>
              </tr>
            }
          </tbody>
        </table>
        <p class="competence-i18n__hint">
          Перевір очима: мітка мовою оригіналу має повернутись дослівно; «Excel», «1С», «Docker» — не перекладені;
          кваліфікатор («Електрик 5 розряду») на місці.
        </p>
      }
    </mat-card-content>
  </mat-card>

  <mat-card class="competence-i18n__card">
    <mat-card-header>
      <mat-card-title>2. Переклад таксономії</mat-card-title>
      <mat-card-subtitle>
        Платний прохід по всій таксономії. Один запуск сам ланцюжить вікна до кінця беклогу — повторно тиснути не треба.
        Ліміт порожній = розмір вікна з конфігу.
      </mat-card-subtitle>
    </mat-card-header>
    <mat-card-content>
      <div class="competence-i18n__row">
        <mat-form-field appearance="outline">
          <mat-label>Розмір вікна</mat-label>
          <input matInput type="number" min="1" [(ngModel)]="translateLimit" placeholder="з конфігу" />
        </mat-form-field>
        <button mat-raised-button color="primary" [disabled]="busy" (click)="runTranslation()">Запустити</button>
      </div>
    </mat-card-content>
  </mat-card>

  <mat-card class="competence-i18n__card">
    <mat-card-header>
      <mat-card-title>3. Запропонувати злиття</mat-card-title>
      <mat-card-subtitle>
        Безкоштовно, лише пропонує. Запускати після того, як покриття дійшло до ~100%: з частковим покриттям знайде
        тільки випадково перекладені пари. Повторювати, доки пропозиції не перестануть зростати.
      </mat-card-subtitle>
    </mat-card-header>
    <mat-card-content>
      <div class="competence-i18n__row">
        <mat-form-field appearance="outline">
          <mat-label>Скільки пар</mat-label>
          <input matInput type="number" min="1" [(ngModel)]="proposeLimit" placeholder="з конфігу" />
        </mat-form-field>
        <button mat-raised-button color="primary" [disabled]="busy" (click)="runProposal()">Запропонувати</button>
      </div>
    </mat-card-content>
  </mat-card>

  <mat-card class="competence-i18n__card competence-i18n__card--danger">
    <mat-card-header>
      <mat-card-title>4. Курація — тут відбувається злиття</mat-card-title>
      <mat-card-subtitle>
        Платно і <strong>незворотно</strong>. Суддя ставить SAME / NARROWER / UNRELATED, зливається лише SAME.
        Переконайся, що бекап знято.
      </mat-card-subtitle>
    </mat-card-header>
    <mat-card-content>
      <div class="competence-i18n__row">
        <mat-form-field appearance="outline">
          <mat-label>Скільки пропозицій</mat-label>
          <input matInput type="number" min="1" [(ngModel)]="curateLimit" />
        </mat-form-field>
        <button mat-raised-button color="warn" [disabled]="busy" (click)="runCuration()">Курувати</button>
      </div>
    </mat-card-content>
  </mat-card>

  <mat-card class="competence-i18n__card">
    <mat-card-header>
      <mat-card-title>5. Перерахувати лічильники</mat-card-title>
      <mat-card-subtitle> Після злиття переможець показує лічильник, який мав сам. Безкоштовно. </mat-card-subtitle>
    </mat-card-header>
    <mat-card-content>
      <button mat-raised-button color="primary" [disabled]="busy" (click)="runRecount()">Перерахувати</button>
    </mat-card-content>
  </mat-card>
</div>
